/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Cashback component for No available service list
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.12.0
 */

import { ImgStatusSuccess, StatusStyled } from '../../../../components/common/Block/Img';
import { IPageCashbackControlTranslation } from '../../../../modules/internationalization/types/pages/cashback';
import { CashbackTextStyled } from '../styled/CashbackStyled';

export interface ICashbackControlServiceNoAvailable {
    translation: IPageCashbackControlTranslation['statusNoAvailableServices'];
}

const CashbackControlServiceNoAvailable = (props: ICashbackControlServiceNoAvailable) => {
    const { translation } = props;

    return (
        <StatusStyled>
            <ImgStatusSuccess/>
            <CashbackTextStyled className="status__title">
                {translation.title}
            </CashbackTextStyled>
            <CashbackTextStyled className="status__sub-title">
                {translation.text}
            </CashbackTextStyled>
        </StatusStyled>
    );
};

export default CashbackControlServiceNoAvailable;
